<template>
    <div class="asdan-background">
        <common-header></common-header>
        <el-row v-if="Role == 'student' && tips !== ''" type="flex" class="mt-20" justify="center">
            <el-col :span="22">
                <el-alert
                :title="tips"
                type="warning"
                show-icon></el-alert>
            </el-col>
        </el-row>
        <el-row type="flex" class="main" justify="center" id="main">
            <el-col :span="22" class="main-content mt-20 mb-20">
                <!--左侧导航-->
                <div class="main-left">
                    <div class="pt-20">
                        <el-menu v-for="(roleRoot, index) in $router.options.routes" :key="index" v-if="matchedPath(roleRoot)" :default-active="getMenuActive()"
                                 class="el-menu-vertical-demo"
                                 router>
                            <el-menu-item v-for="(child, index) in roleRoot.children" :key="index" v-if="!child.hiddenFromMenu" :index="roleRoot.path + '/' + child.path">
                                <i :class="child.iconCls"></i> <span class="ml-5"></span>{{child.name}}
                            </el-menu-item>
                        </el-menu>
                    </div>
                </div>
                <!--右侧内容区-->
                <div class="main-right pl-20 pr-20 mt-20">
                    <div class="content-container">
                        <router-view @setTips="handleTips"></router-view>
                    </div>
                </div>
            </el-col>
        </el-row>


        <!--页面版权-->
        <div class="copyright text-center pb-15">
            <p class="gary">© 2020 ASDAN China.</p>
        </div>
    </div>
</template>

<script>
    import Header from './common/Header.vue'
    import Cookies from 'js-cookie'
    export default {
        components: {
            'common-header': Header
        },
        data() {
            return {
                screenHeight: document.body.clientHeight - 60 - 40,//减去header的60px
                Role: Cookies.get('role'),
                tips:''
            }
        },

        methods: {
            matchedPath(roleRoot) {
                // TODO:去掉需要polyfill的find方法
                return roleRoot.path === this.$route.matched.find(record => !record.parent).path
            },
            getMenuActive() {
                // 导航路径层级+1，目前是两层路径
                const menuDepth = 3
                let path = this.$route.path
                // 超过导航层级则菜单只按照目前最高层匹配
                if (path.split('/').length > menuDepth) {
                    return path.slice(0, path.lastIndexOf('/'))
                } else {
                    return path
                }
            },
            handleTips(val){
                console.log(val,"ab;;;;;")
                this.tips = val;
            },
        },
        mounted() {
            document.getElementById('main').style.minHeight = this.screenHeight + "px";//页面初始化设置最小高度
            //                document.getElementById('main').style.background='white';//页面初始化
            window.onresize = () => {
                return (() => {
                    this.screenHeight = document.body.clientHeight;
                    alert(this.screenHeight)
                })
            };
        },
        watch: {
            screenHeight (val) {
                this.screenHeight = val
                document.getElementById('main').style.height = this.screenHeight - 100 + "px";//检测窗口的大小，并赋值
            }
        },
    }

</script>

<style>


</style>


// WEBPACK FOOTER //
// Home.vue?14723608